<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div class="mc-orders">
        <section class="mc-orders__tabs mc-tabs mc-tabs--fr">
          <div v-if="bonusHistoryLoading && !bonusHistoryLoaded" class="mc-loader">
            <span class="mc-loader__circle"></span>
          </div>

          <div v-if="bonusHistoryError" class="mc-error">
            {{ bonusHistoryError }}
          </div>

          <div v-if="bonusHistoryLoaded" class="mc-tabs__body-wrapper">
            <ul v-if="bonusHistory.length > 0" class="mc-orders__list">
              <li
                v-for="item in bonusHistory"
                :key="item.id"
                class="mc-orders__item mc-orders-item"
              >
                <div class="mc-orders-item__top mc-bonus-history__top">
                  <div class="mc-bonus-history__summary">
                    <span
                      class="mc-orders-item__status mc-bonus-history__quantity"
                      :class="{'mc-bonus-history__quantity--positive': item.quantity > 0}"
                    >
                      {{ item.quantity_formatted }}
                    </span>
                    <span class="mc-bonus-history__date">
                      {{ item.date }}
                    </span>
                  </div>
                  <div class="mc-orders-item__title mc-bonus-history__reason">
                    {{ item.reason }}
                  </div>
                </div>

                <div class="mc-orders-item__bottom">
                  <div class="mc-orders-item__bottom-left mc-bonus-history__meta">
                    <div v-if="item.availability_text">
                      {{ item.availability_text }}
                    </div>
                  </div>

                  <div
                    v-if="item.sale_document && item.sale_document.number"
                    class="mc-orders-item__bottom-right mc-bonus-history__document"
                  >
                    <router-link
                      v-if="item.sale_document.url"
                      :to="item.sale_document.url"
                      class="mc-orders-item__link mc-bonus-history__document-link"
                    >
                      <span class="mc-bonus-history__document-number">
                        {{ item.sale_document.number }}
                      </span>
                      <svg
                        class="mc-bonus-history__document-icon"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        aria-hidden="true"
                      >
                        <use xlink:href="/assets/svg/sprite.svg#arrow-chevron-right"></use>
                      </svg>
                    </router-link>
                    <span v-else class="mc-bonus-history__document-number">
                      {{ item.sale_document.number }}
                    </span>
                  </div>
                </div>
              </li>
            </ul>

            <div v-else class="mc-notifications__empty">
              История начислений и списаний бонусных баллов не найдена
            </div>
          </div>

          <div v-if="loadingMore" class="mc-loader">
            <span class="mc-loader__circle"></span>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  data: () => ({
    loadingMore: false,
  }),
  computed: {
    ...mapGetters([
      'bonusHistory',
      'bonusHistoryLoading',
      'bonusHistoryError',
      'bonusHistoryLoaded',
      'noMoreBonusHistory',
      'bonusHistoryCurrentPage',
    ]),
  },
  created() {
    this.fetchBonusHistory({page: 1});
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions(['fetchBonusHistory']),
    handleScroll() {
      const bottomOfWindow = Math.max(
        window.scrollY,
        document.documentElement.scrollTop,
        document.body.scrollTop
      ) + window.innerHeight >= document.documentElement.scrollHeight - 200;

      if (
        bottomOfWindow
        && !this.loadingMore
        && !this.bonusHistoryLoading
        && this.bonusHistoryLoaded
        && !this.noMoreBonusHistory
      ) {
        this.loadMore();
      }
    },
    async loadMore() {
      if (this.loadingMore || this.bonusHistoryLoading || this.noMoreBonusHistory) {
        return;
      }

      this.loadingMore = true;
      try {
        await this.fetchBonusHistory({page: this.bonusHistoryCurrentPage + 1});
      } finally {
        this.loadingMore = false;
      }
    },
  },
};
</script>

<style scoped>
.mc-bonus-history__top {
  gap: 8px;
}

.mc-bonus-history__summary {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  gap: 12px;
  min-width: 0;
}

.mc-bonus-history__quantity {
  flex-shrink: 0;
  padding: 0;
  border-radius: 0;
  font-size: 20px;
  line-height: 27px;
  font-weight: 500;
  color: #a5a5a5;
  background: transparent;
  text-align: left;
}

.mc-bonus-history__quantity--positive {
  color: #750b0b;
}

.mc-bonus-history__date {
  min-width: 0;
  font-size: 13px;
  line-height: 22px;
  color: #a5a5a5;
}

.mc-bonus-history__reason,
.mc-bonus-history__meta,
.mc-bonus-history__document {
  min-width: 0;
  overflow-wrap: anywhere;
}

.mc-bonus-history__document {
  text-align: right;
}

.mc-bonus-history__document-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
  font-size: 16px;
  line-height: 24px;
}

.mc-bonus-history__document-number {
  min-width: 0;
  font-size: 16px;
  line-height: 24px;
  text-decoration: underline;
  text-underline-offset: 2px;
  overflow-wrap: anywhere;
}

.mc-bonus-history__document-icon {
  flex: 0 0 20px;
}
</style>
